import { Link } from "react-router-dom";
import { platforms } from "../../../mocks/gossip";

const BAND: Record<string, { chip: string; ring: string; bg: string }> = {
  weibo: { chip: "bg-primary-600", ring: "hover:ring-primary-200", bg: "bg-primary-50" },
  douban: { chip: "bg-accent-500", ring: "hover:ring-accent-200", bg: "bg-accent-50" },
  zhihu: { chip: "bg-secondary-500", ring: "hover:ring-secondary-200", bg: "bg-secondary-50" },
  wechat: { chip: "bg-primary-500", ring: "hover:ring-primary-200", bg: "bg-primary-50" },
  tianya: { chip: "bg-accent-600", ring: "hover:ring-accent-200", bg: "bg-accent-50" },
  tieba: { chip: "bg-secondary-600", ring: "hover:ring-secondary-200", bg: "bg-secondary-50" },
};

export default function PlatformBand() {
  return (
    <section className="bg-background-100/70 border-y border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-8 py-10 md:py-14">
        <div className="flex items-end justify-between mb-7">
          <div>
            <h2 className="font-heading font-bold text-foreground-950 text-xl md:text-2xl flex items-center gap-2.5">
              <span className="w-1.5 h-6 rounded-full bg-accent-500 inline-block" aria-hidden="true"></span>
              六大平台，一个入口
            </h2>
            <p className="text-foreground-500 text-sm mt-1.5">每一路爆料都有来处，点击进入对应频道的完整聚合</p>
          </div>
          <span className="hidden md:inline-flex items-center gap-1 text-xs text-foreground-400 whitespace-nowrap">
            <i className="ri-map-pin-line" aria-hidden="true"></i> 全网信源直达
          </span>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {platforms.map((p) => {
            const c = BAND[p.slug];
            return (
              <Link
                key={p.slug}
                to={`/channel/${p.slug}`}
                className={`group flex items-center gap-4 rounded-xl bg-background-50 p-4 md:p-5 ring-1 ring-transparent hover:ring-2 ${c.ring} hover:-translate-y-0.5 transition duration-300`}
              >
                <span className={`w-12 h-12 md:w-14 md:h-14 shrink-0 rounded-xl ${c.bg} flex items-center justify-center`}>
                  <span className={`w-9 h-9 rounded-lg ${c.chip} text-background-50 flex items-center justify-center`}>
                    <i className={`${p.icon} text-lg md:text-xl`} aria-hidden="true"></i>
                  </span>
                </span>
                <span className="min-w-0 flex-1">
                  <span className="flex items-center justify-between gap-2">
                    <span className="font-heading font-bold text-foreground-900 text-base group-hover:text-primary-700 transition whitespace-nowrap">{p.name}</span>
                    <i className="ri-arrow-right-line text-foreground-300 group-hover:text-primary-500 group-hover:translate-x-1 transition text-lg" aria-hidden="true"></i>
                  </span>
                  <span className="block text-xs text-foreground-500 mt-1 line-clamp-2 leading-relaxed">{p.blurb}</span>
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}